import styled, { css } from 'styled-components';
import columnSizes from './column-sizes.variables';
import {
  minWidth,
  minWidth as minWidthGenerator
} from 'helpers/buildMediaQueries';
import { gutterVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

const getGridTemplateMediaQueries = ($hasAside: boolean) =>
  columnSizes
    .map(({ minWidth, containerWidth }) =>
      minWidthGenerator(
        minWidth,
        $hasAside
          ? `grid-template-columns: 1fr ${containerWidth / 3}px minmax(auto, ${
              (containerWidth * 2) / 3
            }px) 1fr;`
          : `
          grid-template-columns: 1fr 0 minmax(auto, ${
            (containerWidth * 2) / 3
          }px) 1fr;`
      )
    )
    .join('');

export const DefaultPage = styled.div<{ $hasAside: boolean }>`
  min-height: 100vh;
  display: grid;
  grid-gap: ${(props) =>
    props.$hasAside ? gutterVariables.GUTTER_DOUBLE : '0px'};
  row-gap: ${gutterVariables.GUTTER_DOUBLE};
  background-color: #f8f8fa;
  grid-template-rows: auto auto 1fr;
  padding-bottom: var(--mobile-app-banner-space, 0);

  ${({ $hasAside }) => getGridTemplateMediaQueries($hasAside)};
  ${minWidthGenerator('md', 'grid-template-rows: auto auto min-content 1fr')};

  footer {
    grid-area: 4 / 1 / 4 / 2;

    ${minWidth('sm', 'grid-area: 5 / 1 / 5 / 5;')}
  }
`;

export const CategoryButtonList = css`
  ul {
    width: 100%;
    text-align: center;
    li {
      display: inline-block;
      margin: 0 ${gutterVariables.GUTTER_HALF} ${gutterVariables.GUTTER}
        ${gutterVariables.GUTTER_HALF};
    }
  }
`;

export const MainContentWrapper = styled.div`
  grid-area: 2 / 1 / 3 / 2;
  margin: 0 auto 40px;

  ${minWidthGenerator(
    'sm',
    `grid-area: 2 / 2 / 3 / 4; padding: 0 ${gutterVariables.GUTTER};`
  )};
  ${minWidth('xl', 'margin: 0 auto 80px; margin-top: 10px;')};

  ${CategoryButtonList}
`;

export const CenteredHeadline = styled.h2`
  display: block;
  text-align: center;
  margin-bottom: ${gutterVariables.GUTTER_DOUBLE};
`;

export const MainPageImage = styled.img`
  width: calc(100% - 32px);
  max-width: 430px;
  height: auto;
  margin: 40px auto 0;
  display: block;
`;

export const MainPagePictureWrapper = styled.div`
  margin-top: ${gutterVariables.GUTTER_PLUS_HALF};
`;
